<template>
  <basic-dialog :show="show" @close="$emit('close')" maxWidth="800">
    <template v-slot:title>Add/Link Services</template>
    <v-row>
      <v-col>
        <gt-multi-select
          v-model="selectedSupplierServices"
          :items="supplierServices"
          label="Supplier Services"
          multiple
          hide-details
          dense
          :outlined="outlinedInputs"
          item-text="name"
          item-value="id"
        />
      </v-col>
      <v-col>
        <agent-group-select
          v-model="selectedAgentGroup"
          :outlined="outlinedInputs"
          hide-details
          dense
          label="Agent Group"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <supplier-list-select-by-type
          v-model="selectedSupplier"
          supplier-type="ACCOMMODATION"
          :outlined="outlinedInputs"
          hide-details
          dense
          label="Target Supplier"
          clearable
        />
      </v-col>

      <v-col>
        <gt-multi-select
          v-model="selectedTargetServices"
          :items="targetServices"
          :outlined="outlinedInputs"
          multiple
          label="Target Services"
          hide-details
          dense
          :disabled="!selectedSupplier"
          :loading="$apollo.loading"
          item-text="name"
          item-value="id"
        />
      </v-col>
    </v-row>
    <v-row align="center">
      <v-col>
        <dates-range-picker
          :gt-date-from-string="dateFrom"
          :gt-date-to-string="dateTo"
          :outlined="outlinedInputs"
          @onRangeSelected="onDatesChange"
          hide-details
          dense
          :disabled="!useDateRange"
        ></dates-range-picker>
      </v-col>
      <v-col>
        <v-switch
          class="mt-0"
          v-model="useDateRange"
          label="Use Date Range"
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3" class="py-0">
        <v-switch v-model="notInUse" label="Not In Use" hide-details dense />
      </v-col>
      <v-col cols="3" class="py-0">
        <v-switch
          v-model="isMandatory"
          label="Is Mandatory"
          hide-details
          dense
        />
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" :disabled="!isValid" @click="onCreate"
        >Create</v-btn
      >
    </template>
    <v-row v-if="debug">
      <v-col>
        <pre>
            {{ linkedServices }}
        </pre>
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import { removeGQLTypename } from "../../../../helpers";
import AgentGroupSelect from "../../shared/AgentGroupSelect.vue";
import BasicDialog from "../../shared/BasicDialog.vue";
import DatesRangePicker from "../../shared/DatesRangePicker.vue";
import SupplierListSelect from "../../shared/SupplierListSelect.vue";
import SupplierListSelectByType from "../../shared/SupplierListSelectByType.vue";
import GtMultiSelect from "../../shared/GtMultiSelect.vue";
const TARGET_SUPPLIER_SERVICES = gql`
  query targetSupplierServices($id: ID!) {
    targetSupplier: supplier(id: $id) {
      id
      services(filter: { not_in_use_eq: false }) {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
`;
export default {
  name: "add-linked-services-dialog",

  components: {
    BasicDialog,
    DatesRangePicker,
    SupplierListSelect,
    AgentGroupSelect,
    SupplierListSelectByType,
    GtMultiSelect,
  },

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    services: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
      dateFrom: "",
      dateTo: "",
      selectedSupplier: null,
      useDateRange: false,
      notInUse: false,
      isMandatory: false,
      selectedTargetServices: [],
      selectedSupplierServices: [],
      selectedAgentGroup: "",
    };
  },

  computed: {
    isValid() {
      return (
        this.selectedSupplierServices.length > 0 &&
        this.selectedTargetServices.length > 0
      );
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    targetServices() {
      return this.targetSupplier
        ? this.targetSupplier.services.edges
            .map(removeGQLTypename)
            .sort((a, b) => a.name.localeCompare(b.name))
        : [];
    },
    supplierServices() {
      return this.services
        .map(removeGQLTypename)
        .filter((s) => !s.notInUse)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    linkedServices() {
      return this.isValid
        ? this.selectedSupplierServices.reduce((acc, service) => {
            for (const targetService of this.selectedTargetServices) {
              acc.push({
                sourceServiceId: service,
                targetServiceId: targetService,
                groupId: this.selectedAgentGroup,
                dateFrom: this.useDateRange ? this.dateFrom : null,
                dateTo: this.useDateRange ? this.dateTo : null,
                notInUse: this.notInUse,
                isMandatory: this.isMandatory,
              });
            }
            return acc;
          }, [])
        : [];
    },
  },

  methods: {
    onDatesChange(dates) {
      console.log(dates);
      this.dateFrom = dates.dateFrom;
      this.dateTo = dates.dateTo;
    },
    onCreate() {
      this.$emit("create", this.linkedServices);
    },
  },

  apollo: {
    targetSupplier: {
      query: TARGET_SUPPLIER_SERVICES,
      variables() {
        return { id: this.selectedSupplier };
      },
      skip() {
        return !this.selectedSupplier;
      },
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/gt/suppliers/linked-services/AddLinkedServicesDialog.vue